// extracted by mini-css-extract-plugin
export default {"filterWrap":"TermAndCoursesFilter_filterWrap__N5sBo"};